import React, { MouseEvent, useEffect, useState } from 'react';
import { Button, Menu, Tooltip } from '@vtbhome/juicyfront';
import { Toast } from '@shared/ui/toast/toast';
import toast from 'react-hot-toast';
import { getQueryError } from '@shared/lib/utils/get-query-error/get-query-error';
import { useCreateProductMutation } from '@entities/product/api/product-api';
import { CreateProductProps } from './types';
import { CACHE_KEY_PRODUCT_CREATE } from '@entities/product/config/api-constants';
import { ModalMutateProduct } from './modal-mutate-product/modal-mutate-product';
import { AllAdd } from '@vtbhome/juicyfront/indexIcon';
import { Typography } from '@shared/ui/typography/typography';

export const CreateProduct: React.FC<CreateProductProps> = ({
    type = 'button',
    additionalProductInfo,
    onSuccess,
    menuList = [],
    ...props
}) => {
    const [, createProductResult] = useCreateProductMutation({
        fixedCacheKey: CACHE_KEY_PRODUCT_CREATE,
    });

    const [isShowModal, setIsShowModal] = useState(false);

    const handleOpen = (e?: MouseEvent) => {
        e?.preventDefault();
        setIsShowModal(true);
    };

    const handleClose = (e?: MouseEvent) => {
        e?.preventDefault();
        setIsShowModal(false);
    };

    useEffect(() => {
        if (isShowModal && createProductResult.isSuccess) {
            onSuccess?.();
            toast.custom((t) => {
                return (
                    <Toast
                        type='success'
                        title='Успешно!'
                        description='Продукт создан'
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            createProductResult.reset();
        } else if (isShowModal && createProductResult.isError) {
            toast.custom((t) => {
                return (
                    <Toast
                        type='error'
                        title='Ошибка!'
                        description={`Не удалось создать продукт.\n${getQueryError(createProductResult)?.message}`}
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            createProductResult.reset();
        }
    }, [isShowModal, createProductResult.isSuccess, createProductResult.isError]);

    return (
        <>
            {type === 'button' && (
                <Button {...props} buttonType='primary' onClick={handleOpen}>
                    Создать продукт
                </Button>
            )}
            {type === 'icon' && (
                <Tooltip position='bottom-end'>
                    <Button
                        {...props}
                        buttonType='secondary'
                        size='s'
                        startAdornment={<AllAdd size='xxs' />}
                        onClick={handleOpen}
                    />
                    <Typography size='body2_short'>Создать продукт</Typography>
                </Tooltip>
            )}
            {type === 'list' && (
                <Menu
                    size='m'
                    position='bottom-start'
                    list={[
                        {
                            label: 'Создать продукт',
                            handler: handleOpen,
                        },
                        ...menuList,
                    ]}>
                    <Button fullWidth buttonType='primary'>
                        Действия
                    </Button>
                </Menu>
            )}
            <ModalMutateProduct
                isShow={isShowModal}
                additionalProductInfo={additionalProductInfo}
                onAccept={handleClose}
                onClose={handleClose}
            />
        </>
    );
};
